<!-- Form Title -->
<h2 class="sectionTitle">Rebate Request - Clone Request</h2>
<!-- Rebate Request - Display Mode -->
<app-rebate-request #rebateRequest (rebateRequestLoadedFlag)="onRebateRequestLoadedFlag($event)"></app-rebate-request>